var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-demo",
      attrs: {
        mode: "horizontal",
        "background-color": "#334157",
        "text-color": "#fff",
        "active-text-color": "#fff"
      }
    },
    [
      _c("el-button", { staticClass: "buttonimg" }, [
        _c("img", {
          staticClass: "showimg",
          attrs: { src: _vm.collapsed ? _vm.imgsq : _vm.imgshow },
          on: {
            click: function($event) {
              return _vm.toggle(_vm.collapsed)
            }
          }
        })
      ]),
      _c(
        "el-submenu",
        { staticClass: "submenu", attrs: { index: "2" } },
        [
          _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.admin))]),
          _c(
            "el-menu-item",
            {
              attrs: { index: "2-3" },
              on: {
                click: function($event) {
                  return _vm.exit()
                }
              }
            },
            [_vm._v("退出")]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }